import React from 'react';
import { MAIN_PRODUCTS } from '../utils/constants';
export const WhatIsIncluded: React.FC = () => {
  const colors = [{
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-900',
    num: 'text-blue-600'
  }, {
    bg: 'bg-green-50',
    border: 'border-green-200',
    text: 'text-green-900',
    num: 'text-green-600'
  }, {
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    text: 'text-orange-900',
    num: 'text-orange-600'
  }, {
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    text: 'text-purple-900',
    num: 'text-purple-600'
  }, {
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-900',
    num: 'text-red-600'
  }];
  return <section className="py-20 px-4 bg-gray-50" data-id="element-315">
      <div className="container mx-auto max-w-4xl" data-id="element-316">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-317">
          ¿Qué incluye el Megapack?
        </h2>

        <div className="space-y-6" data-id="element-318">
          {MAIN_PRODUCTS.map((product, index) => {
          const color = colors[index % colors.length];
          return <div key={index} className={`${color.bg} border ${color.border} rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6 transition-transform hover:-translate-y-1 duration-300`} data-id="element-319">
                <div className="w-16 h-16 rounded-full bg-white/60 flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-320">
                  <span className={`text-2xl font-bold ${color.num}`} data-id="element-321">
                    {index + 1}
                  </span>
                </div>
                <div data-id="element-322">
                  <h3 className={`text-xl md:text-2xl font-bold ${color.text} mb-2`} data-id="element-323">
                    {product.title}
                  </h3>
                  <p className="text-gray-700 text-lg" data-id="element-324">{product.description}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
};